import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    metadataContainer: {},

    metadataHeadingBlock: {
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        borderRadius: 1,
        mb: 1,
        alignItems: 'flex-start',
    },
    metadataHeadingBlockTitle: {
        py: '7px',
        pl: 1,
        flexGrow: 1,
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
    },
    metadataHeadingBlockColumnIcon: {
        flexShrink: 0,
        display: 'inline-flex',
        justifyContent: 'center',
        fontSize: '16px',
        width: '32px',
        pt: 1,
    },

    metadataSectionsList: {},

    metadataSection: {
        borderRadius: 1,
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    metadataSectionHeading: {
        backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.04)),
        alignItems: 'flex-start',
    },
    metadataSectionDragIcon: {
        width: '30px',
        display: 'inline-flex',
        justifyContent: 'center',
        fontSize: '16px',
        flexShrink: 0,
        py: '7px',
    },
    metadataSectionTitle: {
        flexGrow: 1,
        borderLeft: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        py: '6px',
        pl: 1,
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
    },
    metadataSectionTitleNote: {
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.56),
    },
    metadataSectionCheckbox: {
        width: '32px',
        display: 'inline-flex',
        justifyContent: 'center',
        flexShrink: 0,
        mt: '1px',
    },

    metadataFieldsListContainer: {
        borderTop: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        pl: '30px',
        backgroundColor: 'background.default',
    },
    metadataFieldsList: {
        borderLeft: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    metadataFieldBlock: {},
    metadataFieldItem: {
        alignItems: 'flex-start',
        backgroundColor: 'background.default',
        '.metadata-container:not(.metadata-container--active-drag) &:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        },
    },

    metadataFieldItemDragIcon: {
        width: '24px',
        display: 'inline-flex',
        justifyContent: 'center',
        fontSize: '16px',
        flexShrink: 0,
        py: '7px',
    },
    metadataFieldTitle: {
        flexGrow: 1,
        pl: '4px',
        py: '6px',
    },
    metadataFieldTitleNote: {
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.56),
    },

    metadataFieldCheckbox: {
        width: '32px',
        display: 'inline-flex',
        justifyContent: 'center',
        flexShrink: 0,
    },

    metadataInfoPreview: {
        marginTop: '-40px',
        width: 282,
        position: 'absolute',
        left: '100%',
        top: 0,
        ml: 2,
        height: 'calc(100vh - 180px)',
    },
    metadataInfoPreviewTooltip: {
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        width: '100%',
        border: '1px solid',
        borderColor: (theme: Theme) => theme.palette.primary.main,
        borderRadius: '3px',
        maxHeight: '100%',
        overflow: 'auto',
        minHeight: '20px',
        '.collapse-expand-item__children, .tag-item, a': { pointerEvents: 'none' },
    },
};
